export default {
  rs_limit: [1, 10, 60, 250],
  feed_limit: [1, 10, 60, 250],
  custom_sources: [true, true, true, true],
  auto_mentions_hashtags: [true, true, true, true],
  parse_frequency: [5, 2, 1, 1],
  // direct_access: [false, true, true, true],
  // words_blacklist: [true, true, true, true],
  facebook_pub: [true, true, true, true],
  facebook_groups_pub: [true, true, true, true],
  twitter_pub: [true, true, true, true],
  linkedin_pub: [true, true, true, true],
  telegram_pub: [true, true, true, true],
  instagram_pub: [false, true, true, true],
  instagram_stories_pub: [false, false, true, true],
  tiktok_pub: [false, true, true, true],
  youtube_pub: [false, true, true, true],
  threads_pub: [false, true, true, true],
  whatsapp_pub: [false, false, false, true],
  pinterest_pub: [false, false, true, true],
  bluesky_pub: [false, true, true, true],
  google_pub: [false, false, true, true],
  // youtube_pub: [false, false, true, true],
  wonderpush_pub: [true, true, true, true],
  push_notif_pub: [false, false, true, true],
  oneSignal_pub: [true, true, true, true],
  batch_pub: [true, true, true, true],
  // email: [false, true, true, true],
  // automated: [true, true, true, true],
  post_limit: [3 /* FIXME = ? */, 50 /* FIXME = ? */, Infinity /* FIXME = ? */, Infinity /* FIXME = ? */],
  // moderation_tools: [false, true, true, true],
  // optimisation: [false, false, false, true],
  // share_again: [false, false, false, true],
  user_limit: [1, 5, 50, 200],
  // post_frequency: [10, /* FIXME */] // in minutes // TODO
  scheduled_posts_month_limit: [0, 0, 500, Infinity],
  planner: [false, false, true, true],
  moderation: [false, false, false, true],     
  reporting: [false, 50, true, true],
  story_maker: [false, 100, 150, true],
  instant: [false, true, true, true],
  instagram_credentials: [false, false, false, true],
  linkedin_credentials: [false, false, false, true]
}
